const images = {
    cover: `/assets/images/covers/cover_1.jpg`,
    loadingImage: `/assets/images/loading-image.png`,
};

export default images;
